import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons/faCheckCircle";
import Modal, { Header, Footer, Body } from "~/common/ModalReact";
import AvailabitlityCheckFeedback from "./AvailabitlityCheckFeedback";
import { User } from "~/common/Store/models/User";
import isZipcodeEligibleForInstallationService from "../isZipcodeEligibleForInstallationService";
import sendInterestFormEmail from "./sendInterestFormEmail";
interface Props {
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isModalOpen: boolean;
  user: User;
  itemNumber: string;
  itemNumberId: number;
  serviceTierId: number;
}
const InstallationServiceUnavailableModal = ({
  setIsModalOpen,
  isModalOpen,
  user,
  itemNumber,
  itemNumberId,
  serviceTierId
}: Props) => {
  const [zipcodeInput, setZipcode] = useState("");
  const [emailInput, setEmail] = useState("");
  const [emailSubmitted, setEmailSubmitted] = useState(false);
  const [emailSubmitFailed, setEmailSubmitFailed] = useState(false);
  const [zipcodeChecked, setZipcodeChecked] = useState(false);
  const [isValidZipcode, setIsValidZipCode] = useState(false);
  const [isAvailable, setIsAvailable] = useState(false);
  useEffect(() => {
    setZipcode(user?.facebookUserData.zp || "");
    setEmail(user.emailAddress || "");
  }, [user.emailAddress, user.facebookUserData.zp]);
  const showEmail = isValidZipcode && zipcodeChecked && !isAvailable || !zipcodeChecked && emailInput;
  const disableSubmitEmailButton = !showEmail;
  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    await sendInterestFormEmail(zipcodeInput, emailInput, itemNumber).then(result => {
      if (result) {
        setEmailSubmitFailed(false);
        setEmailSubmitted(true);
      } else {
        setEmailSubmitFailed(true);
      }
    });
  };
  const handleZipcodeVerification = async () => {
    const validZipCodeRegExp = new RegExp(/^\d{5}$/);
    if (zipcodeInput && validZipCodeRegExp.test(zipcodeInput) && zipcodeInput > "00501" && zipcodeInput < "99950") {
      setIsValidZipCode(true);
      await isZipcodeEligibleForInstallationService(serviceTierId, zipcodeInput, itemNumberId).then(isEligible => setIsAvailable(isEligible));
    } else {
      setIsValidZipCode(false);
      setIsAvailable(false);
    }
    setZipcodeChecked(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
  };
  return <>
      <Modal isOpen={isModalOpen} onRequestClose={handleModalClose} className="max-h-screen md:max-w-xl" data-sentry-element="Modal" data-sentry-source-file="InstallationServiceUnavailableModal.tsx">
        <form onSubmit={handleSubmit}>
          <Header closeModal={handleModalClose} className="p-5 border-t-0 border-r-0 border-b border-l-0 border-solid border-gray-200 bg-gray-50" data-sentry-element="Header" data-sentry-source-file="InstallationServiceUnavailableModal.tsx">
            Installation Services
          </Header>
          {!emailSubmitted && <Body>
              <div tabIndex={-1} role="dialog" aria-hidden="false" style={{
            display: "block"
          }}>
                <div className="modal-dialog overflow-hidden rounded" role="document">
                  <div className="modal-content">
                    <div className="pt-8 pr-5 pb-8 pl-5">
                      <h3 className="text-center">
                        Enter ZIP Code to check availability
                      </h3>
                      <div id="productform" className="block w-3/4 mr-auto ml-2">
                        <div className="btn-container relative w-full mx-auto">
                          <label>ZIP Code</label>
                          <input className="box-border pl-2 w-full h-10 rounded border border-gray-200 border-solid sm:text-left text-center mb-2" autoComplete="off" pattern="((\d{5}([\-]\d{4})?\s*)(,\s*(\d{5}([\-]\d{4})?))*)" title="Enter ZIP Code or ZIP Codes in a comma seperated list" name="zipcode" id="zipcode" placeholder="Enter ZIP Code" type="text" value={zipcodeInput} onChange={event => setZipcode(event.target.value)} required />
                          {showEmail && <>
                              <label>Email</label>
                              <input className="box-border pl-2 w-full h-10 rounded border border-gray-200 border-solid sm:text-left text-center mb-2" autoComplete="off" name="email" id="email" placeholder="Enter Email Address" type="email" onChange={event => setEmail(event.target.value)} defaultValue={emailInput} pattern="^[a-zA-Z0-9.!#$%&''*+=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)$" title="Please provide a valid email address." required />
                            </>}
                          <input type="button" className="btn btn-primary sm:w-auto w-full h-10 pt-0 pb-0 pl-4 pr-4 mb-0 mt-4 sm:mt-0 sm:rounded-r rounded text-xs" value="Check ZIP Code" onClick={handleZipcodeVerification} />
                        </div>
                        <div className="clears" />
                        {zipcodeChecked && <AvailabitlityCheckFeedback failedEmail={emailSubmitFailed} isValidZipcode={isValidZipcode} isAvailable={isAvailable} isLoggedIn={user.registered || false} />}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Body>}
          {emailSubmitted && <Body>
              {emailSubmitted && !emailSubmitFailed && <div>
                  <p className="text-left">
                    <FontAwesomeIcon icon={faCheckCircle} className="fa mr-2" size="lg" color="#549b33" />
                    Your information has been successfully submitted.
                  </p>
                </div>}
            </Body>}
          <Footer data-sentry-element="Footer" data-sentry-source-file="InstallationServiceUnavailableModal.tsx">
            <button name="close" type="button" className="btn btn-light-alt inline-block w-auto pl-8 pr-8" data-dismiss="modal" aria-label="Close" onClick={handleModalClose}>
              Close
            </button>
            {!emailSubmitted && <input type="submit" className="btn btn-primary inline-block w-auto pl-8 pr-8 ml-2" value="Submit" disabled={disableSubmitEmailButton} />}
          </Footer>
        </form>
      </Modal>
    </>;
};
export default InstallationServiceUnavailableModal;